<template>
    <div class="form-box">
        <div class="form-right from7-r">
            <div style="width:100%;height:6vh;padding-left:1vw;background:#fff;display:flex;align-items: center;border-bottom: 3px solid #ecf0f5;">
                项目关键节点计划
            </div>
            <div style="width:100%;height:calc( 100% - 6vh );position: relative;padding:1vh;background:#fff;overflow: auto;">
                <el-table :data="tableData" style="width: 100%" height="97%" :header-row-class-name="'table-head'">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column prop="index" label="序号" width="200">
                        <template slot-scope="scope">
                            <span>{{scope.row.index}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nodeTypeName" label="关键节点">
                        <template slot-scope="scope">
                            <span>{{scope.row.nodeName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="startTime" label="计划开始时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.startTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="actualStartTime" label="实际开始时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.actualStartTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="completeTime" label="计划完成时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.completeTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="actualCompleteTime" label="实际完成时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.actualCompleteTime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="actualCompleteTime" label="实际完成情况">
                        <template slot-scope="scope">
                            <span  v-if="scope.row.intervalDay>0" style="color:#f00">滞后{{scope.row.intervalDay}}天</span>
                            <span  v-if="scope.row.intervalDay<0" style="color:#409eff">提前{{scope.row.intervalDay}}天</span>
                            <span  v-if="scope.row.intervalDay==0">按时完成</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        
    </div>
</template>

<script>
import base from '../../../../untils/base'
import myHttp from '../../../../untils/port'
import util from '../../../../untils/util'
export default {
    data(){
        return{
            groupId:'',
            dataText: '数据加载中...',
            tableData:[],
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getData()
    },
    methods:{
        //获取数据
        getData(){
            var that = this
            this.tableData = []
            myHttp.projectNodeList({
                projectId:this.groupId
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = i+1
                        list[i].actualCompleteTime = list[i].actualCompleteTime && list[i].actualCompleteTime!=''?list[i].actualCompleteTime.split(' ')[0]:''
                    }
                    that.tableData = list
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
    }
}
</script>

<style scoped>
    .form-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        padding: 1vh;
    }
    .form-right{
        width: 100%;
        height: 100%;
        position: relative;
        
    }

    .father-item:hover,.child-item:hover{
        background: #E7F1FB;
        cursor: pointer;
    }
</style>

<style>
    @import '../../../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #dddddd;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #dddddd;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #dddddd;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #dddddd;
    }
    .from7-r .el-table--border th:nth-child(3),.from7-r .el-table--border td:nth-child(3){
        border-right: 1px solid #dddddd;
    }
    .from7-r .el-table--border th:nth-child(5),.from7-r .el-table--border td:nth-child(5){
        border-right: 1px solid #dddddd;
    }
    .form-right .el-progress-bar__outer{
        background-color: #E0E0E0;
    }
    .form-right .el-progress-bar__innerText{
        font-size: 1vw;
    }
</style>